import React from "react";

const Notification = (props) => {
  const { infoData } = props;

  const handleStatus = (status) => {
    switch (status) {
      case 1:
        return "Kutilmoqda";
      case 2:
        return "Jarayonda";
      case 3:
        return "Tasdiqlangan";
      case 0:
        return "Bekor qilingan";
      default:
        return "";
    }
  };

  const handleStatusClasses = (status) => {
    switch (status) {
      case 3:
        return "success";
      case 0:
        return "danger";
      case 2:
        return "gray";
      case 1:
        return "gray";
      case 4:
        return "warning";
      default:
        return "none";
    }
  };
  const getDateRange = (arg) => {
    const start = new Date(arg);
    const end = new Date();
    const diff = end.getTime() - start.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    return days;
  };
  return (
    <div
      onClick={() => {
        props.onClick(infoData);
      }}
      className="notification__card cursor-pointer hover:bg-slate-300">
      <h1>
        <b> №{infoData?.ad_id} </b> {infoData?.ad?.name}
      </h1>
      <h2 className="my-2">
        {infoData?.user?.full_name}{" "}
        <b>
          {infoData?.amount} {infoData?.currency}
        </b>{" "}
        ehson qilmoqchi
      </h2>

      <p className="notification__card-status">
        <span className={`status--${handleStatusClasses(infoData.status)}`}>
          {handleStatus(infoData.status)}
        </span>
        <b></b>
        {getDateRange(infoData?.created_at) || ""}{" "}
        {getDateRange(infoData?.created_at) ? "kun oldin" : "yaqin vaqt ichida"}
      </p>
    </div>
  );
};

export default Notification;
